<script>
  import Routes from "./Routes.svelte";
</script>

<main>
  <Routes />
</main>
